<template>
</template>

<script>
    export default {
        name: "session-expired",
        mounted: mounted
    }

    function mounted(){
        const vm = this;
        vm.$swal({
            type: 'error',
            target: document.getElementById('swal-app-container'),
            title: 'Session expired',
            text: 'Click OK to login in again',
            preConfirm: () => {
                vm.$store.commit('storeUser', {});
                vm.$store.commit('storeAuthToken', {});
                localStorage.removeItem('user');
                localStorage.removeItem('authToken');
                vm.$router.push({name: 'login'});
            }
        });
    }

</script>

<style scoped>

</style>
